// 获取域的值

import { DomainGroupConfig } from "@/pages/documentCompile/type";
import { arrayToTree, traverseTree } from "@/utils/tree";
import { isLegalPreviewFileType } from "../../utils/file";

export const getDomainMap = (domainConfig: DomainGroupConfig[]) => {
  const map = {} as any;
  traverseTree(domainConfig, (node: DomainGroupConfig) => {
    node.fields?.forEach((field) => {
      map[field.key] = field;
    });
  });
  return map;
};

// 获取域tag 对应的配置，checkbox 会多对对一 ，所以需要返回一个数组
//  isAgree_yes  isAgree_no 对应 isAgree ，不用forEach ,不需要遍历全部
export const getFieldConfigByTag = (domainMap: any, tag: string) => {
  // 先直接查找，适用于大部分非 checkbox 类型的字段
  if (domainMap[tag]) {
    return domainMap[tag];
  }

  // 如果直接查找不到，使用 find + startsWith 查找，主要处理 checkbox 的一对多情况
  const foundKey = Object.keys(domainMap).find((key) => tag.startsWith(key));
  return foundKey ? domainMap[foundKey] : null;
};

// 根据id 获取字段域配置
// export const getFieldConfigById = (domainMap:any,tag: string) => {
//   return domainConfig
//     .flatMap((item) => item.fields)
//     .find((item) => item.id === id);
// };

// 刷新文件树
export const getPackFolderTreeDataByRes = (newViewRes: any[], folderList) => {
  const newViewResTemp = newViewRes.map(i => {
    return {
      ...i,
    }
  })
  // 插入文档卷
  // root view code
  const rootViewCode = newViewResTemp.find(i => i.parentId === 0)
  if (rootViewCode) {
    const juan = folderList.find(i => i.viewId === rootViewCode.viewId) as any
    if (juan) {
      newViewResTemp.unshift({
        ...juan,
        isJuan: true,
        docUrl: juan.catalogDocUrl,
        name: '卷目录.docx',
        parentId: rootViewCode.id,
        folder: false,
        type: '0',
        id: juan.folderId +'000'
      })
    }
  }
  const { tree: packageFolderTreeData, expandKey } = arrayToTree(newViewResTemp, {
    idField: "id",
    pidField: "parentId",
    keyField: "id",
    titleField: "name",
  })
  let firstFileNode = null
  traverseTree(packageFolderTreeData, (node) => {
    if (!node.folder) {
      node.disabled = !isLegalPreviewFileType(node.name)
      if (!node.disabled && !firstFileNode) {
        firstFileNode = node
      }
    }
  })
  return {
    tree: packageFolderTreeData,
    expandKey: expandKey as any[],
    firstFileNode
  }
}
